/**
 * The Events container
 */
import React from "react";
import PropTypes from "prop-types";
import Page from "../components/Page/Page-component";
import { withRouter } from "react-router-dom";
import { Container } from "reactstrap";

/**
 * MintingSection container used as app default landing page
 */
const TX1Tos = (props, context) => {
  return (
    <Page
      id="DataPrivacy"
      title={context.t("Aktionsbedingungen")}
      TX1
      style={{ paddingTop: "50px", fontSize: "2rem" }}
    >
      <Container>
        <div className="staticTextWrapper">
          <h1 className="mb-5">
            Aktionsbedingungen (Registrierungsphase 11.04.-24.04.2024)
          </h1>
          <p>
            Das Angebot gilt für private Endkunden ab 18 Jahren, die sich
            zwischen dem 11.04.2024 und 24.04.2024 auf
            <a target="_blank" rel="noreferrer" href="https://samsung.com/de">
              samsung.com/de
            </a>{" "}
            oder{" "}
            <a target="_blank" rel="noreferrer" href="https://gen3.samsung.com">
              gen3.samsung.com
            </a>
            für eine E-Mail-Benachrichtigung zur Teilnahme an der TX1 Kampagne
            registriert haben und eine E-Mail-Benachrichtigung zur Registrierung
            zu dieser Teilnahme mit Aktionscode erhalten haben. Ebenso gilt es
            für Kunden, die sich zwischen dem 11.04.2024 und 24.04.2024 auf
            ihrem kompatiblen Samsung Smart TV die App &quot;Samsung NFT Gallery
            TV App&quot; herunterladen und sich dort registrieren. Liste der
            kompatiblen Smart-TV-Geräte abrufbar unter{" "}
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.samsung.com/de/lifestyle-tvs/"
            >
              www.samsung.com/de/lifestyle-tvs/
            </a>
            .
          </p>
          <p>Angebot gilt nur, solange der Vorrat reicht.</p>
          <p>Jeder Kunde kann nur einmal an dieser Aktion teilnehmen.</p>
          <p>
            Registrierte Kunden erhalten eines von drei verschiedenen Paul
            Milinski NFTs (s. unten, Auswahl nach dem Zufallsprinzip) kostenlos.
            Die Übermittlung der NFTs an das Wallet der Kunden erfolgt in
            verschiedenen Zeiträumen zwischen dem 11.04.2024 und dem 30.06.2024.
            Die Transaktionsgebühren werden von Samsung übernommen.
          </p>

          <ul>
            <li>TX1 A Gathering Of Shade by Paul Milinski</li>
            <li>TX1 Natures Invitation by Paul Milinski</li>
            <li>TX1 Cliffside Cascade by Paul Milinski</li>
          </ul>

          <p>
            Samsung behält sich eine Änderung, z.B. eine vorzeitige Beendigung
            der Aktion vor. Eine Barauszahlung ist nicht möglich.
          </p>
          <p>
            Ausrichter der Aktion ist Samsung Electronics GmbH, Am Kronberger
            Hang 6, 65824 Schwalbach/Taunus, Deutschland. Vollständige Liste
            aller zur Teilnahme berechtigten Geräte sowie vollständige
            Teilnahmebedingungen unter{" "}
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.samsung.com/de/tvs/gen3gate"
            >
              www.samsung.com/de/tvs/gen3gate
            </a>
            .
          </p>
        </div>
      </Container>
    </Page>
  );
};

/**  define proptype for the 'translation' function  */
TX1Tos.contextTypes = {
  t: PropTypes.func,
};

/** export the component as redux connected component */
export default withRouter(TX1Tos);
